export const testimonies = [
  {
    name: "Temi Makanjuola",
    location: "Lagos, Nigeria",
    testimony:
      "My sofa has been my best purchase so far. Came with the best of customer service and has had no issues since purchase. ",
    id: "1",
  },
  {
    name: "Temi Makanjuola",
    location: "Lagos, Nigeria",
    testimony:
      "My sofa has been my best purchase so far. Came with the best of customer service and has had no issues since purchase. ",
    id: "2",
  },
  {
    name: "Temi Makanjuola",
    location: "Lagos, Nigeria",
    testimony:
      "My sofa has been my best purchase so far. Came with the best of customer service and has had no issues since purchase. ",
    id: "3",
  },
  {
    name: "Temi Makanjuola",
    location: "Lagos, Nigeria",
    testimony:
      "My sofa has been my best purchase so far. Came with the best of customer service and has had no issues since purchase. ",
    id: "4",
  },
  {
    name: "Temi Makanjuola",
    location: "Lagos, Nigeria",
    testimony:
      "My sofa has been my best purchase so far. Came with the best of customer service and has had no issues since purchase. ",
    id: "5",
  },
  {
    name: "Temi Makanjuola",
    location: "Lagos, Nigeria",
    testimony:
      "My sofa has been my best purchase so far. Came with the best of customer service and has had no issues since purchase. ",
    id: "1",
  },
  {
    name: "Temi Makanjuola",
    location: "Lagos, Nigeria",
    testimony:
      "My sofa has been my best purchase so far. Came with the best of customer service and has had no issues since purchase. ",
    id: "2",
  },
];
